import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

export default function useRsAutomotive() {
  const { post } = useApiHelper();

  const registerUser = useMutation(
    (data: any) => post("/rs/user/register", data),
  );

  const dataByKtype = useMutation(
    (data: any) => post("/rs/data/ktype", data),
  );

  const dataByVrm = useMutation(
    (data: any) => post("/rs/data/vrm", data),
  );

  const dataByVin = useMutation(
    (data: any) => post("/rs/data/vin", data),
  );

  const order = useMutation(
    (data: any) => post("/rs/order", data),
  );

  return {
    registerUser,
    dataByKtype,
    dataByVrm,
    dataByVin,
    order
  };
}
